import { css } from 'emotion';

export const clearButton = css`
  margin-right: auto;
`;

export const sortOption = css`
  & > button {
    min-width: 0;
  }
`;
